/**
 * 判断交易的准确性 return false交易成功  true交易失败
 * @param {交易执行器} Actuators  
 * @param {交易type} ty 
 */
let tradeAccuracy = function (Actuators, ty, execer) {
  if ((Actuators == 'none' || Actuators.substring(0, 5) == "user.") && !execer) {
    return false;
  } else {
    if (ty == 1) {
      return true;
    } else {
      return false;
    }
  }
};

export {
  tradeAccuracy
}